<template>
  <div v-if="groupData && groupData.groupHotelData.orderid && groupData.groupHotelData.hotel == hotelId">
    <b-row class="mb-1" align-v="end">
      <b-col md="4">
        <h4 class="header-subtitle mb-1">Orden: {{ groupData.groupHotelData.orderid }}</h4>
        <span class="font-weight-bold text-secondary d-flex justify-content-between">
          <span class="font-weight-bolder">Reservación N.</span> {{ groupData.groupHotelData.reservationNumber || "N/A" }} <br>
        </span>
        <span class="font-weight-bold text-secondary d-flex justify-content-between">
          <span class="font-weight-bolder">Meal plan:</span> {{ groupData.groupHotelData.mealPlan.code || "N/A" }} | {{ groupData.groupHotelData.mealPlan.name || "N/A" }}
        </span>
      </b-col>

      <b-col md="4" class="ml-auto mb-half text-right">
        <b-button size="sm" class="mr-1" @click="showModalInventoryUpgrade(groupData.groupHotelData.id)">
          <b>+ Agregar <br> Categoria</b>
        </b-button>

        <b-button size="sm" class="" @click="showModalAddReservation(groupData.groupHotelData.id)">
          <b>+ Agregar <br> Reservación</b>
        </b-button>

        <ModalInventoryUpgrade
          :room="groupData.groupHotelData.roomtariff"
          :groupData="groupData"
          :isSaving="isSaving"
          :sendAllotment="sendAllotment"
          :refresh="refresh"
        />

        <ModalAddReservation :groupData="groupData" :getBookingInfo="getBookingInfo" :refresh="refresh"
          @change-to-edition-modal="editNewBooking" />
      </b-col>
    </b-row>


    <hr v-if="groupData.groupHotelData.rooms.length > 0">

    <b-card no-body>
      <b-row v-for="roomsList in groupData.groupHotelData.rooms" :key="roomsList.id" :value="roomsList.id"
        :class="`${roomsList.separator} pl-1 mb-1`">
        <b-col md="12" class="p-0">
          <h5 class="font-weight-bolder">{{ roomsList.roomCode }} | {{ roomsList.roomName }}</h5>
        </b-col>

        <b-col class="title">
          <b>Habitaciones</b> {{ roomsList.totalRooms }}
        </b-col>

        <b-col class="title cursorPointer" @click="showModalEditAllotment(groupData.groupHotelData, roomsList)">
          <b>Disponibles </b>
          <a class="text-decoration-underline font-weight-bolder">{{ roomsList.available }}</a>
        </b-col>

        <b-col class="title">
          <b>Reservadas </b> {{ roomsList.reservedBookings }}
        </b-col>

        <b-col class="title">
          <b>Llegada </b> {{ roomsList.arrivaldate }}
        </b-col>

        <b-col class="title">
          <b>Salida</b> {{ roomsList.departuredate }}
        </b-col>
        <b-col class="title">
          <b>Noches</b>{{ roomsList.nightsRooms }}
        </b-col>

        <b-col class="title"><b>Tarifa</b>{{ formatCurrency(roomsList.rate) }} </b-col>
        <b-col class="title"><b>Total</b>{{ formatCurrency(roomsList.total) }} </b-col>
        <b-col class="title noborde">
          <b-button
            :disabled="!roomsList.reservedBookings > 0"
            :variant="roomsList.reservedBookings > 0 ? 'success' : 'secondary'"
            class="text-nowrap"
            v-b-toggle="'my-collapse' + roomsList.roomId + roomsList.arrivaldate + roomsList.departuredate + roomsList.nightsRooms"
            @click.prevent="setbookingInfo(
              groupData.groupHotelData.id,
              roomsList.roomId,
              roomsList.open,
              roomsList,
              groupData.groupHotelData.hotel
            )">Detalles <feather-icon :icon="roomsList.open ? 'ChevronUpIcon' : 'ChevronDownIcon'" /></b-button>
        </b-col>

        <ModalAllotment :room="roomsList" :groupData="groupData" :sendAllotment="sendAllotment" @refresh="refresh" />

        <b-collapse class="mb-2" v-model="roomsList.open">
          <div v-if="roomsList.book.length > 0">
            <div class="mb-half">
              <b>Reservas</b>
            </div>
            <table class="table table-bordered table-sm ">
              <thead>
                <tr>
                  <th class="title"><b>N° POS</b></th>
                  <th class="title"><b>Nombre</b></th>
                  <th class="title"><b>Llegada</b></th>
                  <th class="title"><b>Salida</b></th>
                  <th class="title"><b>Tarifa</b></th>
                  <th class="title"><b>Total</b></th>
                  <th class="title"><b>Total Pagado</b></th>
                  <th class="title"><b>Estatus</b></th>
                  <th class="title"><b>N° reserva </b></th>
                  <th class="title"><b>Acciones</b></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="booking in roomsList.book" :key="booking.id" :value="booking.id"
                  :class="booking.guestReserved ? 'table-warning' : ''">
                  <td class="listItem">
                    <span v-if="booking.orderdetail">
                      POS-{{ booking.orderdetail.order_id }}-{{ booking.orderdetail.orderdetail_id }}
                    </span>
                    <span v-else>--</span>
                  </td>

                  <td class="listItem">
                    {{ booking.givenname }} {{ booking.surname }}
                  </td>

                  <td class="listItem text-nowrap">{{ booking.datein }}</td>
                  <td class="listItem text-nowrap">{{ booking.dateout }}</td>
                  <td class="listItem text-nowrap">{{ formatCurrency(booking.rateInit) }}</td>
                  <td class="listItem text-nowrap">{{ formatCurrency(booking.total) }}</td>
                  <td class="listItem text-nowrap">
                    <span v-if="booking.orderdetail">
                      {{ formatCurrency(booking.orderdetail.totalpay) }}
                    </span>
                    <span v-else>--</span>
                  </td>
                  <td class="listItem">{{ booking.statusName }}</td>
                  <td class="listItem">{{ booking.dingusbooking }}</td>
                  <td class="listItem">
                    <b-button v-if="booking.statusName != 'Cancelled'" size="sm" v-b-tooltip.hover.v-primary
                      title="Editar" class="mr-1" variant="primary" @click="showModal(booking.id)">
                      <feather-icon icon="EditIcon" />
                    </b-button>

                    <b-button v-if="booking.statusName != 'Cancelled'" size="sm" v-b-tooltip.hover.v-primary
                      title="Cancelar" class="mr-1" variant="danger" @click="showModalDelete(booking.id)">
                      <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                  </td>
                  <ModalReference
                    :room="roomInfoData.length > 0 ? roomInfoData[0] : booking"
                    :roomInfoData="booking"
                    :roomCode="booking.roomtypecode"
                    :groupData="groupData"
                    :roomsList="roomsList"
                    :closeBookingDetails="closeBookingDetails"
                    :refresh="refresh" />
                  <ModalDelete :room="booking" :num="roomsList.book.length" :cancelMotive="cancelMotive"
                    :refresh="refresh" />
                  <ModalLocked :room="booking" :num="roomsList.book.length" @refresh="refresh" />
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else-if="roomsList.book.length == 0 && !isloadingDetails.includes(roomsList.roomId)">
            <b-alert variant="danger" show>
              <div class="alert-body text-center">
                <span>
                  <strong>¡Sin registros!</strong> No se encontraron registrados.
                </span>
              </div>
            </b-alert>
          </div>
          <div v-if="isloadingDetails.includes(roomsList.roomId)" class="text-center p-1 collapse">
            <b-spinner label="Loading..." variant="success" />
          </div>

          <hr v-if="!isloadingDetails.includes(roomsList.roomId)">
        </b-collapse>
      </b-row>

    </b-card>
    <!-- <hr>
    <pre>{{ groupData }}</pre> -->
  </div>
  <div v-else>
    <b-alert show class="p-1" variant="warning">No se encontraron habitaciónes para este hotel</b-alert>
  </div>

</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

import ModalReference from "@/modules/groups/components/ModalReference";
import ModalDelete from "@/modules/groups/components/ModalDelete";
import ModalLocked from "@/modules/groups/components/ModalLocked";
import ModalAllotment from "@/modules/groups/components/ModalAllotment";
import ModalInventoryUpgrade from "@/modules/groups/components/ModalInventoryUpgrade";
import ModalAddReservation from "@/modules/groups/components/ModalAddReservation";
import { makeTime, showAlertMessage, toCurrency } from "@/helpers/helpers";
import { acl } from "@/modules/auth/mixins/acl"


export default {
  mixins: [acl],
  async mounted() {
    if (this.groupData.groupHotelData.rooms.length > 0) {
      this.selectedRoom = this.groupData.groupHotelData.rooms[0]
    }
  },
  props: {
    groupData: {
      type: Object,
      required: true
    },
    refreshData: {
      type: Function,
      required: true,
    },
    hotelId: {
      type: Number,
      required: true
    }
  },
  components: {
    ModalReference,
    ModalDelete,
    ModalLocked,
    ModalAllotment,
    ModalInventoryUpgrade,
    ModalAddReservation
  },
  data() {
    return {
      roomInfoData: [],
      isSaving: false,
      isReloadingBookings: false,
      selectedRoom: null,
      showRoomDetails: false,
      isloadingDetails: [],
      cancelMotive: []
    };
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    ...mapActions("groups", [
      "fetchRoomBooking",
      "fetchRoomsTypes",
      "fetchRoomBookingInfo",
      "sendAllomentRoom",
      "fetchGroupRooms",
      "fetchCancelMotive"
    ]),
    ...mapMutations("groups", ["setRoomBookingGroup"]),
    formatCurrency(amount) {
      return toCurrency(amount)
    },

    async showModal(id) {
      const payload = {
        idGroupHotel: "",
        idRoom: "",
        idRoomOnly: id,
        datein: "",
        dateout: "",
      };
      this.roomInfoData = await this.getBookingInfo(payload)
      this.$root.$emit("bv::show::modal", "modal-reference" + id);
    },
    async editNewBooking(payload) {
      const { group } = payload
      this.isReloadingBookings = true
      this.$root.$emit("bv::hide::modal", "modal-add-reservation" + group);
      await this.refresh()
      this.isReloadingBookings = false
    },
    async getBookingInfo(payload) {
      return await this.fetchRoomBookingInfo(payload)
    },
    async refresh() {
      await makeTime()
      await this.refreshData(this.groupData.groupHotelData.id)
    },
    async showModalDelete(id) {
      let idCanal = this.user.canalventa
      this.cancelMotive = await this.fetchCancelMotive(idCanal)
      this.$root.$emit("bv::show::modal", "modal-delete" + id);
    },
    showModalInventoryUpgrade(id) {
      this.$root.$emit("bv::show::modal", "modal-inventory" + id);
    },
    async setbookingInfo(idGroupHotel, idRoom, open, selectedRoom, hotel) {
      this.isloadingDetails.push(idRoom);
      const payload = {
        idGroupHotel: idGroupHotel,
        idRoomOnly: "",
        idRoom: idRoom,
        datein: selectedRoom.arrivaldate,
        dateout: selectedRoom.departuredate,
      };
      if (this.showRoomDetails == false) {
        selectedRoom.book = []
        selectedRoom.open = true
        await this.fetchRoomsTypes(hotel);
        const bookings = await this.fetchRoomBooking(payload);
        selectedRoom.book = bookings
        this.showRoomDetails = true
      } else {
        selectedRoom.book = []
        selectedRoom.open = false
        this.showRoomDetails = false
      }
      this.isloadingDetails = this.isloadingDetails.filter(x=> x != idRoom)
    },
    closeBookingDetails(selectedRoom) {
      selectedRoom.book = []
      selectedRoom.open = false
      this.showRoomDetails = true
    },
    async showModalEditAllotment(group, selectedRoom) {
      if (this.can('groups_menu_show_allotment_modal')) {
        const rooms = await this.fetchGroupRooms({ id: this.groupData.groupHotelData.id, legacy: this.groupData.legacy ? 1 : 0 })
        this.setRoomBookingGroup(rooms)
        this.$root.$emit("bv::show::modal", "modal-allotment" + selectedRoom.roomId);
      }
    },

    async sendAllotment(roomList) {
      this.isSaving = true
      const response = await this.sendAllomentRoom(roomList);
      if (response.status) {
        const rooms = await this.fetchGroupRooms({ id: this.groupData.groupHotelData.id, legacy: this.groupData.legacy ? 1 : 0 })
        this.setRoomBookingGroup(rooms)
        await this.refresh()
        this.isSaving = false
        showAlertMessage('Ok: proceso finalizado', 'InfoIcon', 'El grupo ha sido actualizado exitosamente', 'success', 4000, 'bottom-right')
      }
      return response
    },

    showModalAddReservation(id) {
      this.$root.$emit("bv::show::modal", "modal-add-reservation" + id);
    }
  },

}
</script>


<style lang="scss" scoped>
.group-button {
  font-size: 10px;
  padding: 0.45rem;
}

.header-title {
  font-size: 1.1rem;
  font-weight: bold;
}

.header-subtitle {
  font-size: 1.1rem;
  font-weight: bold;
}

.row.separator {
  margin-top: 42px;
  /* border: 1px solid #000; */
}

.title.col b {
  display: block;
  /* text-align: center; */
  background: #f3f2f7;
}

.title.col {
  text-align: center;
  padding: 0;
  border: solid 1px;
  margin: 0px 0 11px 0;

  /* font-size: 13px; */
}

.listItem.col {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  border: 1px solid rgba(86, 61, 124, 0.2);
}

.titleTotal {
  width: 100%;
  text-align: center;
  padding: 19px 0 15px 0;
  border: 1px solid;
}

.titleTotal b {
  display: block;
  background: #f3f2f7;
  text-transform: uppercase;
  padding: 0px 15px 0px 15px;
}

.titleTotal span {
  display: inline-block;
  border: solid 1px;
  /* padding: 0 10px 0 10px; */
}

.collapse {
  display: block;
  width: 100%;
  /*margin: 22px 0 51px 0;
  padding: 0px 40px 0 13px;*/
}

button.btn.mr-2.btn-secondary.btn-sm {
  font-size: 10px;
  background-color: #22292f !important;
}

.card-body .collapsed,
.card-body .not-collapsed {
  padding: 10px;
  margin: 2px 0 0 0px;
}

a.pdfInfo {
  display: block;
  margin: 3px auto;
  text-align: center;
}

button.btn.mr-1.btn-primary.btn-sm {
  display: inline-block;
  /* width: 20px; */
  margin: 0 0 0 4px !important;
  padding: 5px;
}

button.btn.mr-1.btn-danger.btn-sm {
  display: inline-block;
  /* width: 20px; */
  margin: 0 0 0 8px !important;
  padding: 5px;
}

.table-bordered {
  font-size: 12px;
}

.noborde {
  border: 0 !important;
}

.warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.cursorPointer {
  cursor: pointer;
}

a.text-decoration-underline {
  text-decoration: underline;
}

.dark-layout {
  .title.col b {
    display: block;
    /* text-align: center; */
    background: #f3f2f7;
    color: #22292f;
  }
}
</style>
